//add jquery
import $ from 'jquery';

/**
 * math editor
 * @param event
 */
var editor = function (event) {
    // Prevent multiple script injections
    if (!document.querySelector('script[src="https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"]')) {
        const jsDemoImagesTransform = document.createElement('script');
        jsDemoImagesTransform.type = 'text/javascript';
        jsDemoImagesTransform.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
        jsDemoImagesTransform.async = true;
        document.head.appendChild(jsDemoImagesTransform);
    }

    // Ensure TinyMCE and Wiris plugin are loaded only once
    if (!window.wirisLoaded) {
        window.$ = $;
        window.tinymce = require('tinymce');
        require('@wiris/mathtype-tinymce6'); // Load Wiris TinyMCE plugin
        window.wirisLoaded = true; // Set flag to prevent reloading
    }

    const options = {
        height: 10,
        menubar: false,
        external_plugins: {
            'tiny_mce_wiris': `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
        },
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount '
        ],
        toolbar: [
            ' bold italic |' +
            'tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry '
        ],
        htmlAllowedTags: [ '.*' ],
        htmlAllowedAttrs: [ '.*' ],
        extended_valid_elements: '*[.*]',
    };
};

export default editor;
